import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      marginVertical: 13,
      marginHorizontal: 16,
      alignItems: 'center',
    },
    image: {
      width: 16,
      height: 16,
    },
    text: {
      fontSize: 14,
      ...props.typography.interMedium,
      marginLeft: 12,
    },
  });
